/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import sanitizeIds from '../Utilities/id/sanitizeIds.js';
import { useTranslation } from '../Utilities/i18n/i18n.js';

var ErrorGray = function ErrorGray(_ref) {
  var id = _ref.id,
    ariaLabelProp = _ref.ariaLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ariaLabel = ariaLabelProp || t('Error state icon');
  var uniqueId = id || Math.floor(1000 + Math.random() * 9000);
  var gradientIds = sanitizeIds(['error--gray--b', 'error--gray--c', 'error--gray--d', 'error--gray--e', 'error--gray--f', 'error--gray--g'], uniqueId);
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": ariaLabel,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 200"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--gray--b'],
    x1: "61.38",
    y1: "155.3",
    x2: "61.38",
    y2: "-1.54",
    gradientTransform: "matrix(1 0 0 -1 0 202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#f5f5f5",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".1",
    stopColor: "#ebebeb",
    stopOpacity: ".05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".51",
    stopColor: "#c4c4c4",
    stopOpacity: ".26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".82",
    stopColor: "#acacac",
    stopOpacity: ".41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#a3a3a3",
    stopOpacity: ".5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--gray--c'],
    x1: "122.72",
    y1: "41.78",
    x2: ".06",
    y2: "41.78",
    gradientTransform: "matrix(1 0 0 -1 0 202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--gray--d'],
    x1: "61.55",
    y1: "21.89",
    x2: "122.72",
    y2: "21.89",
    gradientTransform: "matrix(1 0 0 -1 0 202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#bbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#c8c8c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--gray--e'],
    y1: "21.89",
    x2: "61.6",
    y2: "21.89",
    gradientTransform: "matrix(1 0 0 -1 0 202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#bbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--gray--f'],
    x1: "62.13",
    y1: "70.49",
    x2: "62.12",
    y2: "95.19",
    gradientTransform: "matrix(1 0 0 -1 0 202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#f3f3f3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--gray--g'],
    x1: "57.38",
    y1: "38.47",
    x2: "57.52",
    y2: "92.74",
    gradientTransform: "matrix(1 0 0 -1 0 202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#e7e7e7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: gradientIds['error--gray--a'],
    transform: "translate(0 -3.19)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h140v200H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(gradientIds['error--gray--a'], ")")
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.12 124.93l61.6 35.3-.06-118.3L61.11 3.19.33 41.93l-.28 118.3z",
    transform: "translate(0 -3.19)",
    style: {
      isolation: 'isolate'
    },
    opacity: ".47",
    fill: "url(#".concat(gradientIds['error--gray--b'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.06 160.22l61.11-35.36 61.55 35.36-61.11 35.37z",
    transform: "translate(0 -3.19)",
    style: {
      isolation: 'isolate'
    },
    opacity: ".34",
    fill: "url(#".concat(gradientIds['error--gray--c'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.72 160.22v4.42L61.55 200l.05-4.41z",
    transform: "translate(0 -3.19)",
    style: {
      isolation: 'isolate'
    },
    fill: "url(#".concat(gradientIds['error--gray--d'], ")"),
    opacity: ".4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6 195.59l-.05 4.41L0 164.64l.05-4.42z",
    transform: "translate(0 -3.19)",
    style: {
      isolation: 'isolate'
    },
    fill: "url(#".concat(gradientIds['error--gray--e'], ")"),
    opacity: ".4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8 109.18c-4.79-2.78-9.18-3-12.32-1.19l-4.29 2.48c3.14-1.84 7.48-1.59 12.32 1.19 9.58 5.51 17.31 18.82 17.26 29.74 0 5.41-1.94 9.23-5 11.07L74 150c3.09-1.79 5-5.61 5-11.07.11-10.93-7.62-24.29-17.2-29.75z",
    transform: "translate(0 -3.19)",
    fill: "url(#".concat(gradientIds['error--gray--f'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.51 111.66c9.58 5.51 17.31 18.82 17.26 29.74s-7.77 15.34-17.36 9.88-17.31-18.82-17.26-29.74 7.78-15.39 17.36-9.88z",
    transform: "translate(0 -3.19)",
    fill: "url(#".concat(gradientIds['error--gray--g'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.56 140.06a4.66 4.66 0 01-1.72-1.62 3.61 3.61 0 01-.52-1.92v-.62c0-.68.15-1.09.52-1.3s.94-.11 1.72.36a4.12 4.12 0 011.67 1.61 4.21 4.21 0 01.53 1.93v.62c0 .68-.16 1.09-.53 1.3s-.88.05-1.67-.36zm-.73-9.62l-1.15-9.93v-6.29l3.76 2.19v6.29l-1.09 8.62z",
    fill: "#fff"
  })));
};
ErrorGray.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string
};
var ErrorGray$1 = ErrorGray;

export { ErrorGray$1 as default };
